import { CreateCustomRoleDto, CustomRoleDto, CustomRolesApi } from '../../../api-client';
import { useMutation, UseMutationOptions, UseMutationResult } from 'react-query';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { getApiConfiguration } from '../../../common';

type UseCreateCustomRole = (
  options: Omit<
    UseMutationOptions<AxiosResponse<CustomRoleDto>, ErrorResponse, CreateCustomRoleDto>,
    'mutationFn'
  >,
) => UseMutationResult<AxiosResponse<CustomRoleDto>, ErrorResponse, CreateCustomRoleDto>;

export const useCreateCustomRole: UseCreateCustomRole = (options) => {
  const customRolesApi = new CustomRolesApi(getApiConfiguration());
  const tenantId = localStorage.getItem('tenantId') as string;

  return useMutation(
    (createCustomRoleDto: CreateCustomRoleDto) =>
      customRolesApi.createCustomRole(tenantId, createCustomRoleDto),
    options,
  );
}
